import { When } from '@teamsparta/react';
import { Flex } from '@teamsparta/stack-flex';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import type { GNBDropdownMenu, GNBLinkMenu } from '@/components/gnb/constants';
import { GNB_ELEMENT_ID, GNB_MENUS } from '@/components/gnb/constants';
import { RemoteConfigKeys } from '@/constants/remoteConfigKeys';
import type { ScrollDirection } from '@/lib/utils/businessLogics/_common/useScrollDirection';
import { useTypedInhouseRemoteConfig } from '@/lib/utils/businessLogics/landing';
import { useEditProfileModal } from '@/store/community';
import { MobileGNBOpenAtom } from '@/store/landing';

import Only from '../common/Only';
import { DropdownMenus, Hamburger, Logo, SideBar, User } from './components';
import { useGetScrollDirection, useToggleSideBar } from './hook';
import * as S from './style';

/**
 * @todo refactor: hook 분리
 */
interface Props {
  // 스크롤 방향에 따라 GNB 위치가 달라지지 않아야 하는 경우 사용
  scrollDirectionOverRide?: ScrollDirection;
  setHubTooltipDisappear?: (open: boolean) => void;
}
export function GNB({
  scrollDirectionOverRide,
  setHubTooltipDisappear,
}: Props) {
  const setMobileGNBOpen = useSetAtom(MobileGNBOpenAtom);
  const { sideBarOpen, toggleSideBar, closeSideBar } = useToggleSideBar();

  const { open: openEditProfileModal } = useEditProfileModal();
  function handleClickEditProfile() {
    closeSideBar();
    openEditProfileModal();
  }

  const { scrollDirection } = useGetScrollDirection(scrollDirectionOverRide);

  const gnbEduMenu = useTypedInhouseRemoteConfig(
    RemoteConfigKeys.GNB_EDU_MENU,
    'json',
  );
  const gnbMenusCombined: (GNBDropdownMenu | GNBLinkMenu)[] = GNB_MENUS.map(
    (menu) =>
      menu.name === '교육'
        ? gnbEduMenu && gnbEduMenu.items
          ? { ...menu, items: gnbEduMenu.items }
          : menu
        : menu,
  );

  useEffect(() => {
    setHubTooltipDisappear && setHubTooltipDisappear(sideBarOpen);
  }, [sideBarOpen]);

  return (
    <>
      <S.Container
        id={GNB_ELEMENT_ID}
        animate={{ y: scrollDirection === 'up' ? 0 : -100 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <Flex
          justify='between'
          align='center'
          padding='12px 16px'
          fullWidth
          fullHeight
          style={{ maxWidth: 1232 }}
        >
          <Flex gap={32} align='center' fullWidth>
            <Logo />
            <Only.Desktop>
              <When condition={scrollDirection === 'up'}>
                <DropdownMenus gnbMenus={gnbMenusCombined} />
              </When>
            </Only.Desktop>
          </Flex>
          <Only.Desktop>
            <User setHubTooltipDisappear={setHubTooltipDisappear} />
          </Only.Desktop>
          <Only.Mobile>
            <Hamburger
              open={sideBarOpen}
              onClick={() => {
                setMobileGNBOpen((prev) => !prev);
                toggleSideBar();
              }}
            />
          </Only.Mobile>
        </Flex>
      </S.Container>
      <SideBar
        opened={sideBarOpen}
        close={closeSideBar}
        onClickEditProfile={handleClickEditProfile}
      />
    </>
  );
}
